export default __webpack_public_path__ + "static/media/eye.435abac1.svg";